import { UserTypeConfig } from '../../interfaces/users/users.interfaces';

export const SUPERVISOR_TYPE = 4;

export const USER_TYPES: readonly UserTypeConfig[] = [
  {
    type: 0,
    kind: 'admin',
    filter: 'admins',
    label: 'Administrador',
    tabLabel: 'Administradores',
    webAccess: true,
  },
  {
    type: 1,
    kind: 'courier',
    filter: 'couriers',
    label: 'Repartidor',
    tabLabel: 'Repartidores',
    webAccess: false,
  },
  {
    type: 2,
    kind: 'warehouse',
    filter: 'warehouse-staff',
    label: 'Almacén',
    tabLabel: 'Almacén',
    webAccess: false,
  },
  {
    type: 3,
    kind: 'sales',
    filter: 'sales-staff',
    label: 'Compras',
    tabLabel: 'Compras',
    webAccess: false,
  },
  {
    type: SUPERVISOR_TYPE,
    kind: 'supervisor',
    filter: 'supervisors',
    label: 'Supervisor',
    tabLabel: 'Supervisores',
    webAccess: true,
  },
];

/**
 * Busca la configuración de un tipo de usuario.
 *
 * @param type Tipo de usuario según el backend.
 * @returns Su configuración, o la de Administrador si el tipo no está en la lista (Superuser).
 */
export function getUserType(type: number): UserTypeConfig {
  return USER_TYPES.find((item) => item.type === type) ?? USER_TYPES[0];
}

/**
 * Busca la configuración de un tipo de usuario por el filtro de la URL.
 *
 * @param filter Segmento de la URL, por ejemplo `admins`.
 * @returns Su configuración, o `undefined` si el filtro no es de un tipo (como `all`).
 */
export function getUserTypeByFilter(filter: string): UserTypeConfig | undefined {
  return USER_TYPES.find((item) => item.filter === filter);
}
